import { Injectable, computed, inject, signal } from "@angular/core";
import { DigitalSignatureServiceProxy } from "@api/core";
import { SignatureCertificateStatus } from "@api/core.models";
import { Observable, catchError, of, tap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class DigitalCertificateService {
    private readonly _api = inject(DigitalSignatureServiceProxy);

    private readonly _status = signal<SignatureCertificateStatus | null>(null);

    readonly status = this._status.asReadonly();

    readonly hasCertificate = computed(() => this._status()?.hasCertificate ?? true);

    refresh(): Observable<SignatureCertificateStatus | null> {
        return this._api.certificateStatus().pipe(
            catchError(() => of(null)),
            tap((status) => this._status.set(status))
        );
    }

    clear(): void {
        this._status.set(null);
    }
}
